import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, Spinner } from "react-bootstrap";
import TabellaLista from '../../../../components/Tabella/TabellaLista';
import { ChipFilter, filtroMultiplo } from '../../../../components/Tabella/ChipFilter';
import { RangeFilterButton, dataNelPeriodo } from '../../../../components/Tabella/RangeFilterButton';
import MyApiClient from '../../../../../api-client/MyApiClient';
import { sports } from "../../../../components/Util/enum";
import DEFAULT_USER from "../../../../../images/DEFAULT_USER.png";
import { dateTimeSort } from '../../../../components/Util/oders';

import { formattaPrezzo } from "../../../../components/Util/prezzi";
// Valori dei filtri a chip, come compaiono nella lista.
const STATO_OPTIONS = ['Pagato', 'Non pagato', 'Rimborsato', 'Annullato'];

export const UserLessonsTable = ({ lessonId, cardTitle = '', headerButtons = null }) => {

    const navigate = useNavigate();


    const [data_json, setDataJson] = useState(null);
    // Chip a scelta multipla: all'inizio tutti accesi
    const [statoFilter, setStatoFilter] = useState(STATO_OPTIONS);
    const [periodo, setPeriodo] = useState({});

    const filteredData = useMemo(
        () => data_json && data_json.filter((row) =>
            filtroMultiplo(statoFilter, STATO_OPTIONS, row.status_label?.label) && dataNelPeriodo(row.bookingDate, periodo.periodo)),
        [data_json, statoFilter, periodo],
    );

    const [loadingShowed, setLoadingShowed] = useState(false);

    const baseColumns = [
        {
            Header: 'Creazione',
            Footer: 'Creazione',
            accessor: 'createdAt',
            disableGlobalFilter: true,
            sortType: dateTimeSort,
            disableFilters: true
        },
        {
            Header: 'Nome e cognome',
            accessor: 'playerName',
            Cell: ({ row }) => {
                const isJunior = row.original.isJunior;
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img
                            src={row.original.imageUrl ? row.original.imageUrl : DEFAULT_USER}
                            alt={row.original.playerName}
                            style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                marginRight: '10px'
                            }}
                        />
                        <div>
                            {row.original.playerName}
                            {isJunior && (
                                <div>
                                    <span style={{fontSize: '12px', color: 'white', backgroundColor: 'red', marginLeft: '10px', padding: '2px 5px', borderRadius: '5px'}}>Junior</span>
                                </div>
                            )}
                        </div>
                    </div>
                )
            }
        }
    ];

    // Aggiungi colonne condizionalmente
    const conditionalColumns = [
        {
            Header: 'Data inizio',
            Footer: 'Data inizio',
            accessor: 'startDate',
            disableGlobalFilter: true,
        },
        {
            Header: 'Data fine',
            Footer: 'Data fine',
            accessor: 'endDate',
            disableGlobalFilter: true,
        }
    ];

    const remainingColumns = [
        
        {
            Header: 'Prezzo',
            Footer: 'Prezzo',
            accessor: 'price',
            disableGlobalFilter: true,
        },
        {
            Header: 'Stato pagamento',
            Footer: 'Stato pagamento',
            accessor: 'status_label',
            disableGlobalFilter: true,
            Cell: ({ value }) => {
                return (
                    <div className="d-flex align-items-center">
                        <i className={`fa fa-circle me-1 ${value?value.class:''}`}></i>
                        {value?value.label:''}
                    </div>
                )
            },
        },
    ];

    // Combina tutte le colonne
    const data_column = [...baseColumns, ...conditionalColumns, ...remainingColumns];

    function openDetail(row) {
        navigate('/struttura/booking/userlessons/'+row.id);
    }

    const fetchData = async () => {
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                let token = tokenDetails.idToken;
                const apiClient = new MyApiClient();

                console.log(lessonId);

                setLoadingShowed(true);
                const [bookingLessons] = await Promise.all([
                    apiClient.getUserBookingLessons(token, lessonId)
                ]);
                setLoadingShowed(false);

                if(bookingLessons) {
                    let data = [];
                    bookingLessons.forEach(element => {

                        // Combina bookingDate con startTime e endTime
						const formatDateWithTime = (bookingDate, time) => {
							if (!bookingDate || !time) return '-';
							
							// Crea la data completa combinando bookingDate e time
							const dateTimeString = `${bookingDate}T${time}:00`;
							const dateTime = new Date(dateTimeString);
							
							// Formatta come dd/MM/yyyy HH:mm
							const day = String(dateTime.getDate()).padStart(2, '0');
							const month = String(dateTime.getMonth() + 1).padStart(2, '0');
							const year = dateTime.getFullYear();
							const hours = String(dateTime.getHours()).padStart(2, '0');
							const minutes = String(dateTime.getMinutes()).padStart(2, '0');
							
							return `${day}/${month}/${year} ${hours}:${minutes}`;
						};

						const formattedStartDate = formatDateWithTime(element.bookingDate, element.startTime);
						const formattedEndDate = formatDateWithTime(element.bookingDate, element.endTime);

                        const createdAt = element.createdAt;
                        const dateCreated = new Date(createdAt);
                        const options2 = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' };
                        const formattedDate = dateCreated.toLocaleDateString('it-IT', options2);

                        let image = null;
                        if(element.juniorName) {
                            if(element.juniorPicture && element.juniorPicture.uri) {
                                image = element.juniorPicture.uri;
                            }
                        } else {
                            if(element.playerPicture && element.playerPicture.uri) {
                                image = element.playerPicture.uri;
                            }
                        }

                        let status = null;
                        if(element.status === 'PAID') {
                            status = {
                                "label": "Pagato",
                                "class": "text-success"
                            };
                        } else if(element.status === 'UNPAID') {
                            status = {
                                "label": "Non pagato",
                                "class": "text-primary"
                            };
                        } else if(element.status === 'REFUNDED') {
                            status = {
                                "label": "Rimborsato",
                                "class": "text-warning"
                            };
                        } else if(element.status === 'CANCELLED') {
                            status = {
                                "label": "Annullato",
                                "class": "text-error"
                            };
                        }

                        let sportLabel = '';
                        sports.forEach(element2 => {
                            if(element2.value === element.sportType) {
                                sportLabel = element2.label;
                            }
                        });

                        let row = {
                            "id": element.id,
                            "bookingDate": element.bookingDate,
                            "playerName": element.juniorName ? element.juniorName : element.playerName,
                            "lesson_name": element.lesson_name,
                            "sportType": sportLabel,
                            "startDate": formattedStartDate,
                            "endDate": formattedEndDate,
                            "price": formattaPrezzo(element.price),
                            "status": element.status,
                            "status_label": status,
                            "imageUrl": image,
                            "isJunior": element.juniorName !== '',
                            "createdAt": formattedDate,
                        };
                        data.push(row);
                        
                    });
                    setDataJson(data);
                }
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    
    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            {!lessonId && (
                <Modal className="fade" show={loadingShowed} centered>
                    <Modal.Body className="text-center">
                    <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                    <div>Caricamento in corso...</div>
                    </Modal.Body>
                </Modal>
            )}

            <TabellaLista
                cardTitle={cardTitle.trim()}
                hasSearch={true}
                searchPlaceholder={'Cerca per nome'}
                hasFilter={false}
                filterControl={
                    <div className="sid-chip-filters">
                        {/* Periodo (TASK #14, 21/10/2026): giorno della prenotazione */}
                        <RangeFilterButton label="Periodo" ranges={[{ key: 'periodo', label: 'Data della prenotazione', type: 'date' }]} value={periodo} onApply={setPeriodo} />
                        <ChipFilter label="Stato pagamento" options={STATO_OPTIONS} value={statoFilter} onChange={setStatoFilter} multiple />
                    </div>
                }
                data_column={data_column}
                data_json={filteredData}
                openColumn={'playerName'}
                openRow={(row) => openDetail(row)}
                hasAddMore={false}
                linkAddMore={'/struttura/booking/userLessons'}
                labelAddMore={'Nuova vendita lezione'}
                headerButtons={headerButtons}
                modalCallBack={() => setModalCentered(true)}
                sort_by={'createdAt'}
                sort_type={'desc'}
            />
        </>
    )
}
export default UserLessonsTable;